/* eslint-disable react/prop-types */
import React from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import "./google.m.css";

const GoogleSearchResults = ({ data }) => {
  return (
    <div>
      <div>
        {data.map(i => (
          <HorizontalStoryCard key={i.link} story={i} boxPadding={false} showSection increaseFontSize />
        ))}
      </div>
    </div>
  );
};

export default GoogleSearchResults;

const HorizontalStoryCard = ({ story = {} }) => {
  return (
    <Link href={story.link}>
      <div styleName={`horizontal-card remove-padding`}>
        {/* done */}
        <img
          onError={ev => (ev.target.style.display = "none")}
          src={get(story, "pagemap.cse_image[0].src", "")}
          style={{ objectFit: "cover", width: "100%", height: "200px", maxHeight: "200px" }}
          alt="img"
          className="responsive-img"
        />

        <div styleName={`story-description box-padding increaseHeadingFont padding-top`}>
          {get(story, "pagemap.NewsArticle[0].articleSection", null) ? (
            <div styleName="section">
              {get(story, "pagemap.NewsArticle[0].articleSection", "Story")}
              {/* {story.pagemap.NewsArticle[0].articleSection ? story.pagemap.NewsArticle[0].articleSection : ``}  */}
            </div>
          ) : (
            ``
          )}
          {/* */}
          <div>
            <h2 styleName="headline" className="headline" style={{ color: "#231f20" }}>
              {get(story, "pagemap.metatags[0][og:title]", "")}
            </h2>
          </div>
          {/*  */}
          {get(story, "pagemap.metatags[0].author", null) && (
            <div styleName="author-details">
              <span style={{ color: "#231f20" }}>{get(story, "pagemap.metatags[0].author", null)}</span>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};
